// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ffb7b839","87":"d704e2cd","113":"0ddac46d","212":"e671d8a7","218":"9475bbb2","465":"6e87dd4f","671":"13311344","944":"4f2f6771"}[chunkId] + ".chunk.js";
};